import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import DriverEarning from './DriverEarning';
import Earningreports from './Earningreports';
import FleetAdminEarning from './FleetAdminEarning';
import { useSelector } from "react-redux";
import { makeStyles} from '@mui/styles';
import { MAIN_COLOR, SECONDORY_COLOR, FONT_FAMILY } from "../common/sharedFunctions";
import { Typography } from '@mui/material';
import MaterialTable from 'material-table';
import { ThemeProvider } from '@mui/material/styles';
import tableTheme from "styles/tableStyle";
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
const useStyles = makeStyles({
  tabs: {

    "& .MuiTabs-indicator": {
      backgroundColor: SECONDORY_COLOR,
      height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
      color: MAIN_COLOR
    }
  },
  typography:{
    fontFamily:FONT_FAMILY
  }
})

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function EatEarningReports() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings || {});
  const eatOrders = useSelector(state => state.eatdata.orders || []);
  const [selectedRow, setSelectedRow] = React.useState(null);

  const formatAmount = (value) => {
    const number = parseFloat(value || 0);
    const formatted = number.toLocaleString(settings.country === 'Vietnam' ? 'vi-VN' : 'en-US', {
      minimumFractionDigits: settings.decimal,
      maximumFractionDigits: settings.decimal
    });
    return settings.swipe_symbol === false ? `${settings.symbol || ''}${formatted}` : `${formatted}${settings.symbol || ''}`;
  };

  const monthlyRows = React.useMemo(() => {
    const rowsByMonth = {};
    eatOrders.forEach(order => {
      const createdAt = order.createdAt || order.placedAt || order.updatedAt;
      if (!createdAt || !['DELIVERED', 'PAID', 'COMPLETE'].includes(order.status)) return;
      const date = new Date(createdAt);
      const key = `${date.getFullYear()}-${date.getMonth()}`;
      const pricing = order.pricing || {};
      if (!rowsByMonth[key]) {
        rowsByMonth[key] = {
          year: date.getFullYear(),
          monthsName: date.toLocaleString(undefined, { month: 'long' }),
          total_orders: 0,
          customerTotal: 0,
          restaurantNet: 0,
          deliveryFee: 0,
          courierEarning: 0,
          platformNet: 0,
          refunds: 0
        };
      }
      rowsByMonth[key].total_orders += 1;
      rowsByMonth[key].customerTotal += Number(pricing.total || order.total || 0);
      rowsByMonth[key].restaurantNet += Number(pricing.restaurantNet || pricing.restaurantSubtotal || 0);
      rowsByMonth[key].deliveryFee += Number(pricing.deliveryFee || order.deliveryFee || 0);
      rowsByMonth[key].courierEarning += Number(pricing.courierEarning || pricing.deliveryFee || 0);
      rowsByMonth[key].platformNet += Number(pricing.platformNet || pricing.platformFee || 0);
      rowsByMonth[key].refunds += Number(order.refundAmount || pricing.refundAmount || 0);
    });
    return Object.values(rowsByMonth).sort((left, right) => right.year - left.year || new Date(`${right.monthsName} 1, ${right.year}`).getMonth() - new Date(`${left.monthsName} 1, ${left.year}`).getMonth());
  }, [eatOrders]);

  const columns = [
    { title: t('year'), field: 'year' },
    { title: t('months'), field: 'monthsName' },
    { title: 'Commandes Eats', field: 'total_orders' },
    { title: 'Total client', field: 'customerTotal', render: rowData => formatAmount(rowData.customerTotal) },
    { title: 'Net restaurants', field: 'restaurantNet', render: rowData => formatAmount(rowData.restaurantNet) },
    { title: 'Livraisons', field: 'deliveryFee', render: rowData => formatAmount(rowData.deliveryFee) },
    { title: 'Gains livreurs', field: 'courierEarning', render: rowData => formatAmount(rowData.courierEarning) },
    { title: 'Commission plateforme', field: 'platformNet', render: rowData => formatAmount(rowData.platformNet) },
    { title: 'Remboursements', field: 'refunds', render: rowData => formatAmount(rowData.refunds) }
  ];

  return (
    <ThemeProvider theme={tableTheme}>
      <MaterialTable
        title="Allô Driver Eats - Rapports"
        columns={columns}
        data={monthlyRows}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "8px",
          padding: "20px",
          boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
        }}
        onRowClick={(evt, selectedRow) => setSelectedRow(selectedRow.tableData.id)}
        options={{
          exportButton: true,
          rowStyle: (rowData) => ({
            backgroundColor: selectedRow === rowData.tableData.id ? '#f5f5f5' : '#fff'
          }),
          ...TableStyle()
        }}
        localization={localization(t)}
      />
    </ThemeProvider>
  );
}

export default function AllReports() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  const classes =useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className={classes.tabs} variant="scrollable">
        {auth.profile.usertype === "fleetadmin" || auth.profile.usertype === "admin" ?
          <Tab style={{marginRight:"20px"}} label={ <Typography className={classes.typography}>{t('driver_earning')}</Typography>} {...a11yProps(0)} />
        :null}
        {auth.profile.usertype === "admin" ?
          <Tab style={{marginRight:"20px"}} label={ <Typography className={classes.typography}>{t('earning_reports')}</Typography>} {...a11yProps(1)} />
        :null}
        {auth.profile.usertype === "admin" ?
          <Tab style={{marginRight:"20px"}} label={t('fleetadmin_earning_reports')} {...a11yProps(2)} />
        :null}
        {auth.profile.usertype === "admin" ?
          <Tab style={{marginRight:"20px"}} label="Allô Driver Eats" {...a11yProps(3)} />
        :null}
        </Tabs>
      </Box>
        <TabPanel value={value} index={0}>
          <DriverEarning/>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Earningreports/>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <FleetAdminEarning/>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <EatEarningReports/>
        </TabPanel>
    </Box>
  );
}